// @flow
export const isDev = () : boolean => process.env.NODE_ENV === 'development'
export const isTest = (): boolean => process.env.NODE_ENV === 'test'



// WEBPACK FOOTER //
// ./src/core/env.js